import React from "react";
import { FaInstagram, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import logo from "../assets/images/logo.png";

const Footer = () => {
    return (
        <footer className="text-white py-8" style={{
            background: `linear-gradient(to left, ${"#28AE9F"}, ${"#185a9d"})`,
        }}>
            <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-start space-y-8 md:space-y-0">
                {/* Left Section */}
                <div className="md:w-1/2">
                    <div className="flex items-center space-x-3">
                        <img src={logo} width={80} className="rounded" alt="Invetix Logo" />
                        <h2 className="text-2xl font-bold">INVETIX POS</h2>
                    </div>
                    <p className="mt-2 text-sm leading-tight max-w-sm">
                        Smarter, faster, and seamless POS solutions for your business.
                    </p>
                </div>

                {/* Center Section - Contact */}
                <div className="md:w-1/2 text-start">
                    <h3 className="text-lg font-semibold mb-3">Contact</h3>
                    <p>
                        Email:{" "}
                        <a href="mailto:sales@invetix.in" className="text-white">
                            sales@invetix.in
                        </a>
                    </p>

                    {/* <p>
            Phone:{" "}
            <a href="tel:+919902446710" className="text-blue-400">
              +91 9902446710
            </a>
          </p> */}
                </div>

                {/* <div className="md:w-1/2 text-start">
                    <h3 className="text-lg font-semibold mb-3">Legal</h3>
                    <div className="mt-2">
                        <a href="/terms-and-conditions" className="text-gray-400 hover:text-white mx-3">Terms & Conditions</a>
                        <a href="/privacy-policy" className="text-gray-400 hover:text-white mx-3">Privacy Policy</a>
                    </div>
                </div> */}

                {/* Right Section - Social */}
                <div className="md:w-1/8 text-start">
                    <h3 className="text-lg font-semibold mb-3">Social</h3>
                    <div className="flex space-x-4">
                        <a
                            href="https://x.com/invetix8358"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white hover:text-blue-400 transition md:text-blue-700 md:hover:text-white"
                        >
                            <FaXTwitter size={20} />
                        </a>
                        <a
                            href="https://www.instagram.com/invetix.in?igsh=dG9uamI0ZWdvYWU2"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white hover:text-blue-400 transition md:text-blue-700 md:hover:text-white"
                        >
                            <FaInstagram size={20} />
                        </a>
                        <a
                            href="https://www.linkedin.com/in/invetix"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white hover:text-blue-400 transition md:text-blue-700 md:hover:text-white"
                        >
                            <FaLinkedin size={20} />
                        </a>
                    </div>
                </div>
            </div>

            {/* Bottom Section */}
            <div className="container mx-auto mt-8 text-center">
                <p className="mb-0">
                    &copy; {new Date().getFullYear()} INVETIX POS. All rights reserved.
                </p>
                <div className="mt-2">
                    <a href="/terms-and-conditions" target="_blank" className="text-gray-400 hover:text-white mx-3">Terms & Conditions</a>
                    <a href="/privacy-policy" target="_blank" className="text-gray-400 hover:text-white mx-3">Privacy Policy</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;